import React from 'react'
import PropTypes from 'prop-types'
import {Box, MenuItem, TextField} from '@material-ui/core';
import getObjectValue from 'libs/getObjectValue'
import {withStyles} from '@material-ui/styles';
import clsx from 'clsx';
import Typography from "./Typography";

const style = theme => ({
    root: {
        marginBottom: theme.spacing(),
    },
    contrastSelectValue: {
        minHeight: theme.spacing(4)
    },
    selected: {
        background: `${theme.palette.primary.main} !important`,
        color: `${theme.palette.secondary.contrastText} !important`

    },
    border: {
        border: `1px solid ${theme.palette.common.white}`,
    },
    subLabel: {
        fontStyle: 'italic'
    },
    hidden: {
        display: 'none'
    }
})
export const createSelectItem = (value, label, subLabel, hidden = false) => ({
    value,
    label: label !== undefined ? label : value,
    subLabel,
    hidden
})

function Select(
    {
        formikProps,
        id,
        label,
        items,
        noError,
        className,
        required,
        classes,
        disabled,
        onChange = () => {
        },
        alwaysEditable = false,
        showErrorWithoutTouched = false
    }) {
    const errorValue = getObjectValue(id, formikProps.errors, '')
    const touched = getObjectValue(id, formikProps.touched, false)
    const value = getObjectValue(id, formikProps.values, '')
    const editable = alwaysEditable || getObjectValue('_editable', formikProps.values, true);

    const isError = !noError && !!errorValue && (showErrorWithoutTouched || !!touched)

    let _label = label;
    if (_label && required) _label += '*';

    const _value = items.findIndex(x => {
        if (typeof x === 'string') return x === value
        return x.value === value
    }) < 0 ? '' : value;

    return (
        <TextField
            disabled={disabled || !editable}
            className={clsx(classes.root, className)}
            select
            label={_label}
            name={id}
            onChange={(event) => {
                formikProps.handleChange(event);
                onChange(event)
            }}
            onBlur={formikProps.handleBlur}
            value={_value}
            error={isError}
            helperText={noError ? undefined : isError ? errorValue : ' '}
            fullWidth
            classes={{
                root: classes.contrast,
                // selectMenu: classes.selected,
            }}
            SelectProps={{
                MenuProps: {
                    classes: {
                        paper: classes.border
                    }
                },
            }}
        >
            {
                items.map((item, i) => {
                    const isStr = typeof item === 'string';
                    const value = isStr ? item : item.value;
                    const label = isStr ? item : item.label;
                    const subLabel = isStr ? undefined : item.subLabel;

                    return (
                        <MenuItem key={i}
                                  classes={{
                                      selected: classes.selected
                                  }}
                                  value={value}
                                  className={clsx(classes.contrastSelectValue, item.hidden && classes.hidden)}
                        >
                            <Box>
                                <Typography variant="inherit" noWrap>{label}</Typography>
                                { !!subLabel &&
                                    <Typography variant="subtitle2" noWrap className={classes.subLabel}>{subLabel}</Typography>
                                }
                            </Box>

                        </MenuItem>
                    )
                })
            }
        </TextField>
    )
}

Select.propTypes = {
    className: PropTypes.string,
    formikProps: PropTypes.object,
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.shape({
                value: PropTypes.any.isRequired,
                label: PropTypes.string.isRequired,
            }),
            PropTypes.string.isRequired,
        ])
    )
}

Select.defaultProps = {
    items: []
}

export default withStyles(style)(Select)
